import {
  CodeTaskProperties,
  PropertiesType,
  TaskProperties,
  TaskPropertiesForm,
} from '../types';
import { DataMode } from '../zodSchemas/taskProperties';

export const DATA_MODE_BY_PARAM = {
  initial_state_csv: 'inputDataMode',
  input_csv_file: 'inputCsvDataMode',
  workflow_data: 'workflowDataMode',
  plate_map_csv: 'plateMapDataMode',
} as const;

type ModeFieldKey = keyof typeof DATA_MODE_BY_PARAM;

const fieldForParam = (
  paramName: string
): (typeof DATA_MODE_BY_PARAM)[ModeFieldKey] | undefined =>
  DATA_MODE_BY_PARAM[paramName as ModeFieldKey] ?? undefined;

export const getParamMode = (
  props: TaskProperties | CodeTaskProperties,
  key: string
): DataMode | undefined => {
  const field = fieldForParam(key);

  if (field === 'inputDataMode') {
    return props.propertiesType === PropertiesType.Code
      ? props.inputDataMode
      : undefined;
  }

  return field ? props[field] : undefined;
};

export const buildModePatchForParam = (
  paramName: string,
  newMode: DataMode
): Partial<TaskPropertiesForm> => {
  const field = fieldForParam(paramName);
  return field ? ({ [field]: newMode } as Partial<TaskPropertiesForm>) : {};
};

export const isConnectorizedInput = (
  props: TaskProperties | CodeTaskProperties,
  key: string
): boolean => getParamMode(props, key) === DataMode.Connector;

export const getInitialDataModesForTaskType = (
  taskType: string
): Partial<TaskProperties> => {
  const supports = taskType === 'run_liquid_handler' || taskType === 'run';
  return supports
    ? {
        workflowDataMode: DataMode.Manual,
        inputCsvDataMode: DataMode.Manual,
        plateMapDataMode: DataMode.Manual,
      }
    : {};
};

export const getFormModesFromProps = (
  props: TaskProperties
): Pick<
  TaskPropertiesForm,
  'workflowDataMode' | 'inputCsvDataMode' | 'plateMapDataMode'
> => ({
  workflowDataMode: props.workflowDataMode ?? DataMode.Manual,
  inputCsvDataMode: props.inputCsvDataMode ?? DataMode.Manual,
  plateMapDataMode: props.plateMapDataMode ?? DataMode.Manual,
});

export const isFileUploadEnabled = (
  scriptName: string | null,
  workcellId: string
): boolean =>
  workcellId === 'ucbProd' && scriptName === 'initialise_volume_tracking';
